module.exports = __webpack_public_path__ + "img/jug-main.7057e9e6.png";